import "./bootstrap";
import store from "./store";
import VueTheMask from "vue-the-mask";
import VueWait from "vue-wait";
import Toasted from "vue-toasted";
import Panel from "../../assets/user/js/components/Panel/Panel";
import Spacing from "../../assets/user/js/components/Spacing/Spacing.vue";
import Field from "./components/_www/Field";
import Btn from "./components/_www/Btn";
import money from 'v-money'
import Loading from './core/Loading';
import VTooltip from "v-tooltip";
import Vue from "vue";
import VueCountryCode from "vue-country-code";

const escavadorGlobalComponents = require.context(
  "@escavador/global-components",
  true,
  /.*\.(vue)$/
);

escavadorGlobalComponents.keys().forEach((file) => {
  const Component = escavadorGlobalComponents(file).default;

  if (Component.name) {
    Vue.component(Component.name, Component);
  }
});

Vue.component("Panel", Panel);
Vue.component("Spacing", Spacing);
Vue.component("Field", Field);
Vue.component("Btn", Btn);
Vue.component("Loading", Loading);

Vue.component("Modal", require("./components/Modal.vue").default);
Vue.component("Popover", require("./components/Popover.vue").default);
Vue.component("Icon", require("./components/Icon.vue").default);
Vue.component("Compartilhar", require("./components/Compartilhar.vue").default);
Vue.component("Reportar", require("./components/Reportar.vue").default);
Vue.component(
  "UserUpdateLattes",
  require("./components/user/UserUpdateLattes.vue").default
);
Vue.component("Monitorar", require("./components/Monitorar.vue").default);
Vue.component("Seguidores", require("./components/Seguidores.vue").default);
Vue.component(
  "GraficosApi",
  require("./components/api/GraficosApi.vue").default
);
Vue.component("JsonView", require("./components/api/JsonView.vue").default);
Vue.component("Cobranca", require("./components/api/Cobranca.vue").default);
Vue.component("Tokens", require("./components/api/Tokens.vue").default);
Vue.component(
  "CriarToken",
  require("./components/api/CriarToken.vue").default
);
Vue.component(
  "TokenRevokeModal",
  require("./components/api/TokenRevokeModal.vue").default
);
Vue.component(
  "EmpresaFormModal",
  require("./components/api/EmpresaFormModal.vue").default
);
Vue.component(
  "BotaoEnviarRelatorioConsumo",
  require("./components/api/BotaoEnviarRelatorioConsumo.vue").default
);
Vue.component('ChangelogsApi', require('./components/api/ChangelogsApi.vue').default);
Vue.component("OrganizacaoApi", require("./components/api/OrganizacaoApi.vue").default);
Vue.component("AdicionarUsuarioOrganizacaoModal", require("./components/api/AdicionarUsuarioOrganizacaoModal.vue").default);
Vue.component('RemoverUsuarioOrganizacaoModal', require('./components/api/RemoverUsuarioOrganizacaoModal.vue').default);
Vue.component('OrganizacaoRolesPermissoesModal', require('./components/api/OrganizacaoRolesPermissoesModal.vue').default);
Vue.component(
  "ConfirmarPagamentoModal",
  require("./components/api/ConfirmarPagamentoModal.vue").default
);
Vue.component("BotaoPdf", require("./components/geral/BotaoPdf").default);
Vue.component(
  "BotaoMonitorar",
  require("./components/geral/BotaoMonitorar").default
);
Vue.component(
  "BotaoSolicitarAutos",
  require("./components/geral/BotaoSolicitarAutos").default
);
Vue.component("ChatBot", require("./components/chatbot/ChatBot").default);
Vue.component(
  "RelatorioConsumoApi",
  require("./components/api/RelatorioConsumoApi.vue").default
);
Vue.component(
  "PopupConsentimento",
  require("./components/_www/PopupConsentimento/PopupConsentimento.vue").default,
);
Vue.component(
  "ServicosApi",
  require("./components/api/ServicosApi.vue").default
);
Vue.component("BotaoConfirmarNovoTokenCallback", require("./components/api/BotaoConfirmarNovoTokenCallback.vue").default);
Vue.component("ModalConfirmarNovoTokenCallback", require("./components/api/ModalConfirmarNovoTokenCallback.vue").default);

// Modais campanha
Vue.component("modal-ca", require("./components/modals/ModalCA.vue").default);

Vue.component(
  "LoadingBox",
  require("./components/loading/LoadingBox.vue").default
);

Vue.component('PlaygroundApi', require('./components/api/PlaygroundApi.vue').default);
Vue.component(
  "EnvolvidoProcessoFormModal",
  require("./components/api/playground/EnvolvidoProcessosFormModal.vue").default
);

Vue.component('CertificadosDigitais', require('./components/api/CertificadosDigitais.vue').default);
Vue.component('AdicionarCertificadoDigitalModal', require('./components/api/AdicionarCertificadoDigitalModal.vue').default);
Vue.component('ExcluirCertificadoDigitalModal', require('./components/api/ExcluirCertificadoDigitalModal.vue').default);



Vue.use(VueTheMask);
Vue.use(VueWait);
Vue.use(Toasted);
Vue.use(money, { precision: 4 });
Vue.use(require("vue-cookies"));
Vue.use(VTooltip);
Vue.use(VueCountryCode);

const app = new Vue({
  el: "#escavador-app",
  wait: new VueWait(),
  store,
  delimiters: ["${", "}"],
  mounted() {
    EventBus.$on("loading-show", () => {
      if (typeof this.$refs.loading !== "undefined")
        this.$refs.loading.classList.remove("is-hidden");
    });
    EventBus.$on("loading-hide", () => {
      if (typeof this.$refs.loading !== "undefined")
        this.$refs.loading.classList.add("is-hidden");
    });
  },
});
